export default class SeatSelectorFrame {
  constructor (config) {
    this.containerId = config.container
    this.token = config.token

    this.populate()

    return this
  }

  populate () {
    var root = document.getElementById(this.containerId)

    var iframe = document.createElement('iframe')
    iframe.src = process.env.API_URL + '?token=' + this.token
    iframe.width = '100%'
   // iframe.height = '100%'
    iframe.frameborder = 0
    iframe.id = 'ss-frame'
    // iframe.style = 'position: fixed; right: 0; bottom: 0; left: 0; top: 0'

    root.appendChild(iframe)
  }

  bindEvent (element, eventName, eventHandler) {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false)
    } else if (element.attachEvent) {
      element.attachEvent('on' + eventName, eventHandler)
    }
  }
}



// WEBPACK FOOTER //
// ./src/SeatSelectorFrame.js